import axios from 'axios'
import library from '../../../utils/Library'

export const getSubscriberUserCorpEntities = async (userId) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('subscribers') +
    `/getSubscriberUserCorpEntities/${userId}`

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      offset: 0,
      limit: 1000
    }
  })
}
